// import { useEffect, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import Splide from "@splidejs/splide";

// import "@splidejs/splide/dist/css/splide.min.css";
// import "../assets/css/pages/about_slider.css";

// import arrowRightUp from "../assets/images/Home/Arrow Right Up.svg";
// import mobileFrameFallback from "../assets/images/About/mobile2.png";
// import fadebottom from "../assets/images/About/3.png";

// export default function FrameSliderSection({ fields }) {

//     /* ===============================
//        HOOKS
//     =============================== */

//     const navigate = useNavigate();

//     const left2Ref = useRef(null);
//     const leftRef = useRef(null);
//     const centerRef = useRef(null);
//     const rightRef = useRef(null);
//     const right2Ref = useRef(null);
//     const autoplayRef = useRef(null);

//     /* ===============================
//        DATA
//     =============================== */

//     const sliderImages = Array.isArray(fields?.slider_images)
//         ? fields.slider_images
//         : [];

//     const flags = Array.isArray(fields?.flags)
//         ? fields.flags
//         : [];

//     const titleHtml = fields?.title || "";
//     const subtitleHtml = fields?.subtitle || "";
//     const buttonText = fields?.button_text || "";
//     const buttonUrl = fields?.button_url || "";

//     const mobileFrame =
//         fields?.mobile_frame?.url || mobileFrameFallback;

//     const getSlide = (i) =>
//         sliderImages[i]?.image?.url || "";

//     const getFlag = (i) =>
//         flags[i]?.image?.url || "";

//     /* ===============================
//        SPLIDE INIT (OLD LOGIC RESTORED)
//     =============================== */

//     useEffect(() => {
//         if (!sliderImages.length) return;

//         let left2, left, center, right, right2;

//         const options = {
//             type: "loop",
//             perPage: 1,
//             perMove: 1,
//             arrows: false,
//             pagination: false,
//             drag: false,
//             speed: 800,
//             clones: 6,
//             easing: "cubic-bezier(.42,0,.58,1)",
//         };

//         left2 = new Splide(left2Ref.current, options).mount();
//         left = new Splide(leftRef.current, options).mount();
//         center = new Splide(centerRef.current, options).mount();
//         right = new Splide(rightRef.current, options).mount();
//         right2 = new Splide(right2Ref.current, options).mount();

//         // 🔁 ORIGINAL RELATIVE POSITIONS
//         left2.go("-2");
//         left.go("-1");
//         center.go(0);
//         right.go("+1");
//         right2.go("+2");

//         const prevBtn = document.querySelector(".splide_prev");
//         const nextBtn = document.querySelector(".splide_next");

//         const goPrev = () => {
//             left2.go("-1");
//             left.go("-1");
//             center.go("-1");
//             right.go("-1");
//             right2.go("-1");
//             resetAutoplay();
//         };

//         const goNext = () => {
//             left2.go("+1");
//             left.go("+1");
//             center.go("+1");
//             right.go("+1");
//             right2.go("+1");
//             resetAutoplay();
//         };

//         function startAutoplay() {
//             autoplayRef.current = setInterval(() => {
//                 nextBtn?.click();
//             }, 4000);
//         }

//         function resetAutoplay() {
//             clearInterval(autoplayRef.current);
//             startAutoplay();
//         }

//         prevBtn?.addEventListener("click", goPrev);
//         nextBtn?.addEventListener("click", goNext);

//         startAutoplay();

//         return () => {
//             clearInterval(autoplayRef.current);
//             prevBtn?.removeEventListener("click", goPrev);
//             nextBtn?.removeEventListener("click", goNext);

//             left2.destroy();
//             left.destroy();
//             center.destroy();
//             right.destroy();
//             right2.destroy();
//         };
//     }, [sliderImages.length]);

//     /* ===============================
//        SAFE RETURN
//     =============================== */

//     if (!sliderImages.length || flags.length < 5) return null;

//     /* ===============================
//        JSX
//     =============================== */

//     return (
//         <section className="background-color-secondary desktop-only">

//             {/* HEADER */}
//             <div className="social-header">
//                 {titleHtml && (
//                     // <h2
//                     //     dangerouslySetInnerHTML={{
//                     //         __html: titleHtml.replace(/^<p>|<\/p>$/g, ""),
//                     //     }}
//                     // />
//                     <h2
//                         dangerouslySetInnerHTML={{
//                             __html: fields?.title || "",
//                         }}
//                     />

//                 )}

//                 {subtitleHtml && (
//                     <p
//                         className="tagline"
//                         dangerouslySetInnerHTML={{ __html: subtitleHtml }}
//                     />
//                 )}

//                 {buttonText && buttonUrl && (
//                     <button
//                         className="social-btn"
//                         onClick={() => navigate(buttonUrl)}
//                     >
//                         <p>{buttonText}</p>
//                         <img src={arrowRightUp} alt="Arrow icon" />
//                     </button>
//                 )}
//             </div>

//             <div className="padding-global">
//                 <div className="container-large">

//                     <div className="mobile-frame">
//                         <img src={mobileFrame} alt="Mobile Frame" />
//                     </div>
//                     <div className="fade-bottom">
//                         <img src={fadebottom} alt="Fade effect" />
//                     </div>

//                     {/* FLAGS */}
//                     {[0, 1, 2, 3, 4].map(i => (
//                         <img
//                             key={i}
//                             className={`flag flag${i + 1}`}
//                             src={getFlag(i)}
//                             alt={flags[i]?.image?.alt || `Flag ${i + 1}`}
//                         />
//                     ))}

//                     <div className="slider_main-wrapper">

//                         {[
//                             ["is-left-2", left2Ref],
//                             ["is-left", leftRef],
//                             ["is-center", centerRef],
//                             ["is-right", rightRef],
//                             ["is-right-2", right2Ref],
//                         ].map(([cls, ref]) => (
//                             <div className={`splide ${cls}`} ref={ref} key={cls}>
//                                 <div className="splide__track">
//                                     <ul className="splide__list">
//                                         {[0, 1, 2, 3, 4].map(i => (
//                                             <li className="splide__slide" key={i}>
//                                                 <img
//                                                     src={getSlide(i)}
//                                                     className="slide_image"
//                                                     alt={sliderImages[i]?.image?.alt || `View ${i + 1}`}
//                                                 />
//                                             </li>
//                                         ))}
//                                     </ul>
//                                 </div>
//                                 {cls !== "is-center" && <div className="splide__overlay" />}
//                             </div>
//                         ))}

//                         {/* ARROWS */}
//                         <div className="arrows-wrapper">
//                             <div className="splide_prev">
//                                 <svg width="33" height="33" viewBox="0 0 33 33">
//                                     <path
//                                         d="M21.833 25.8335L9.83301 16.5002L21.833 7.16683"
//                                         stroke="#19C1B7"
//                                         strokeWidth="2.66667"
//                                         strokeLinecap="round"
//                                     />
//                                 </svg>
//                             </div>
//                             <div className="splide_next">
//                                 <svg width="33" height="33" viewBox="0 0 33 33">
//                                     <path
//                                         d="M11.167 25.8335L23.167 16.5002L11.167 7.16683"
//                                         stroke="#19C1B7"
//                                         strokeWidth="2.66667"
//                                         strokeLinecap="round"
//                                     />
//                                 </svg>
//                             </div>
//                         </div>

//                     </div>
//                 </div>
//             </div>
//         </section>
//     );
// }






























import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Splide from "@splidejs/splide";

import "@splidejs/splide/dist/css/splide.min.css";
import "../assets/css/pages/about_slider.css";

import arrowRightUp from "../assets/images/Home/Arrow Right Up.svg";
import mobileFrameFallback from "../assets/images/About/mobile2.png";
import fadebottom from "../assets/images/About/3.png";

export default function FrameSliderSection({ fields }) {

    /* ===============================
       HOOKS
    =============================== */

    const navigate = useNavigate();

    const left2Ref = useRef(null);
    const leftRef = useRef(null);
    const centerRef = useRef(null);
    const rightRef = useRef(null);
    const right2Ref = useRef(null);
    const autoplayRef = useRef(null);

    /* ===============================
       DATA
    =============================== */

    const sliderImages = Array.isArray(fields?.slider_images)
        ? fields.slider_images
        : [];

    const flags = Array.isArray(fields?.flags)
        ? fields.flags
        : [];

    const titleHtml = fields?.title || "";
    const subtitleHtml = fields?.subtitle || "";
    const buttonText = fields?.button_text || "";
    const buttonUrl = fields?.button_url || "";

    const mobileFrame =
        fields?.mobile_frame?.url || mobileFrameFallback;

    const getSlide = (i) =>
        sliderImages[i]?.image?.url || "";

    const getFlag = (i) =>
        flags[i]?.image?.url || "";

    /* ===============================
       SPLIDE INIT (OLD LOGIC RESTORED)
    =============================== */

    useEffect(() => {
        if (!sliderImages.length) return;

        let left2, left, center, right, right2;

        const options = {
            type: "loop",
            perPage: 1,
            perMove: 1,
            arrows: false,
            pagination: false,
            drag: false,
            speed: 800,
            clones: 6,
            easing: "cubic-bezier(.42,0,.58,1)",
        };

        left2 = new Splide(left2Ref.current, options).mount();
        left = new Splide(leftRef.current, options).mount();
        center = new Splide(centerRef.current, options).mount();
        right = new Splide(rightRef.current, options).mount();
        right2 = new Splide(right2Ref.current, options).mount();

        left2.go("-2");
        left.go("-1");
        center.go(0);
        right.go("+1");
        right2.go("+2");

        const prevBtn = document.querySelector(".splide_prev");
        const nextBtn = document.querySelector(".splide_next");

        const goPrev = () => {
            left2.go("-1");
            left.go("-1");
            center.go("-1");
            right.go("-1");
            right2.go("-1");
            resetAutoplay();
        };

        const goNext = () => {
            left2.go("+1");
            left.go("+1");
            center.go("+1");
            right.go("+1");
            right2.go("+1");
            resetAutoplay();
        };

        function startAutoplay() {
            autoplayRef.current = setInterval(() => {
                nextBtn?.click();
            }, 4000);
        }

        function resetAutoplay() {
            clearInterval(autoplayRef.current);
            startAutoplay();
        }

        prevBtn?.addEventListener("click", goPrev);
        nextBtn?.addEventListener("click", goNext);

        startAutoplay();

        return () => {
            clearInterval(autoplayRef.current);
            prevBtn?.removeEventListener("click", goPrev);
            nextBtn?.removeEventListener("click", goNext);

            left2.destroy();
            left.destroy();
            center.destroy();
            right.destroy();
            right2.destroy();
        };
    }, [sliderImages.length]);

    /* ===============================
       SAFE RETURN
    =============================== */

    if (!sliderImages.length || flags.length < 5) return null;

    /* ===============================
       JSX
    =============================== */

    return (
        <section className="background-color-secondary desktop-only">

            {/* HEADER */}
            <div className="social-header">
                {titleHtml && (
                    <h2
                        dangerouslySetInnerHTML={{
                            __html: fields?.title || "",
                        }}
                    />
                )}

                {subtitleHtml && (
                    <p
                        className="tagline"
                        dangerouslySetInnerHTML={{ __html: subtitleHtml }}
                    />
                )}

                {buttonText && buttonUrl && (
                    <button
                        className="social-btn"
                        onClick={() => navigate(buttonUrl)}
                    >
                        <p>{buttonText}</p>
                        <img src={arrowRightUp} alt="Arrow icon" />
                    </button>
                )}
            </div>

            <div className="padding-global">
                <div className="container-large">

                    <div className="mobile-frame">
                        <img src={mobileFrame} alt="Mobile Frame" />
                    </div>

                    <div className="fade-bottom">
                        <img src={fadebottom} alt="Fade effect" />
                    </div>

                    {/* FLAGS */}
                    {[0, 1, 2, 3, 4].map(i => (
                        getFlag(i) && (
                            <img
                                key={i}
                                className={`flag flag${i + 1}`}
                                src={getFlag(i)}
                                alt={flags[i]?.image?.alt || ""}
                            />
                        )
                    ))}

                    <div className="slider_main-wrapper">

                        {[
                            ["is-left-2", left2Ref],
                            ["is-left", leftRef],
                            ["is-center", centerRef],
                            ["is-right", rightRef],
                            ["is-right-2", right2Ref],
                        ].map(([cls, ref]) => (
                            <div className={`splide ${cls}`} ref={ref} key={cls}>
                                <div className="splide__track">
                                    <ul className="splide__list">
                                        {[0, 1, 2, 3, 4].map(i => (
                                            <li className="splide__slide" key={i}>
                                                {getSlide(i) && (
                                                    <img
                                                        src={getSlide(i)}
                                                        className="slide_image"
                                                        alt={sliderImages[i]?.image?.alt || ""}
                                                    />
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                {cls !== "is-center" && <div className="splide__overlay" />}
                            </div>
                        ))}

                        {/* ARROWS */}
                        <div className="arrows-wrapper">
                            <div className="splide_prev">
                                <svg width="33" height="33" viewBox="0 0 33 33">
                                    <path
                                        d="M21.833 25.8335L9.83301 16.5002L21.833 7.16683"
                                        stroke="#19C1B7"
                                        strokeWidth="2.66667"
                                        strokeLinecap="round"
                                    />
                                </svg>
                            </div>
                            <div className="splide_next">
                                <svg width="33" height="33" viewBox="0 0 33 33">
                                    <path
                                        d="M11.167 25.8335L23.167 16.5002L11.167 7.16683"
                                        stroke="#19C1B7"
                                        strokeWidth="2.66667"
                                        strokeLinecap="round"
                                    />
                                </svg>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
}
